//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'PricingPage',
  components: {
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    AboutTabs: () => import('@/components/about/AboutTabs.vue'),
    ComparisonTable: () => import('@/components/pricing/ComparisonTable.vue'),
    HomeFaqs: () => import('@/components/home-page/HomeFaqs.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
  },
  watch: {
    userCurrency: { // @toDo @Pavlo why we need to watch userCurrency and resend getPlans
      handler(toCurrencyCode) {
        if (toCurrencyCode) {
          this.$store.dispatch('subscription/getPlans');
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      userCurrency: 'user/currencyCode',
    }),
    pageTitle() {
      return this.$t('nav.pricing');
    },
    pageDescription() {
      return this.$t('pricing.subheading');
    },
    breadcrumbList() {
      return [
        {
          name: this.$t('nav.pricing'),
          link: this.$link('/pricing').fullPath(),
          active: true,
        },
      ];
    },
  },
};
